// extracted by mini-css-extract-plugin
export var base = "_1r-0";
export var updateBanner = "_1r-1";